var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      staticStyle: { width: "100%", "padding-top": "0px" },
      model: {
        value: _vm.formIsValid,
        callback: function ($$v) {
          _vm.formIsValid = $$v
        },
        expression: "formIsValid",
      },
    },
    [
      _c(
        "v-card-text",
        [
          _c("ExecutionResultsDialog", {
            ref: "executionResultsDialog",
            attrs: {
              title: "Move Data Source",
              shouldClose: !_vm.assignOptions.isTestRun,
            },
            on: {
              close: function ($event) {
                return _vm.close()
              },
            },
          }),
          _vm._v(" "),
          _c("v-autocomplete", {
            attrs: {
              items: _vm.selectionItems,
              rules: [_vm.rules.required, _vm.rules.noSynonyms],
              required: "",
              "item-text": "Name",
              "item-value": "Id",
              "return-object": "",
              label: "Discrete data source to merge",
            },
            model: {
              value: _vm.formObject.dataSourceToMerge,
              callback: function ($$v) {
                _vm.$set(_vm.formObject, "dataSourceToMerge", $$v)
              },
              expression: "formObject.dataSourceToMerge",
            },
          }),
          _vm._v(" "),
          _vm.isDepthHeightDatum
            ? [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", md8: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.datumList,
                            rules: [_vm.rules.required],
                            required: "",
                            "item-text": "DatumName",
                            label: "Depth/Height Datum",
                            "return-object": "",
                          },
                          model: {
                            value: _vm.targetDatum,
                            callback: function ($$v) {
                              _vm.targetDatum = $$v
                            },
                            expression: "targetDatum",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", "offset-md1": "", md3: "" } },
                      [
                        _vm.targetDatum && _vm.targetDatum.DatumType
                          ? _c("v-text-field", {
                              attrs: { disabled: "", label: "Datum Type" },
                              model: {
                                value: _vm.targetDatum.DatumType.Name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.targetDatum.DatumType,
                                    "Name",
                                    $$v
                                  )
                                },
                                expression: "targetDatum.DatumType.Name",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", md5: "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Start value (meters)",
                            type: "number",
                            rules: [
                              _vm.rules.depthHeightRules,
                              _vm.rules.requiredNumber,
                            ],
                          },
                          model: {
                            value: _vm.formObject.depthHeightStartValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formObject,
                                "depthHeightStartValue",
                                _vm._n($$v)
                              )
                            },
                            expression: "formObject.depthHeightStartValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", md5: "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "End value (meters)",
                            type: "number",
                            rules: [
                              _vm.rules.depthHeightRules,
                              _vm.rules.requiredNumber,
                            ],
                          },
                          model: {
                            value: _vm.formObject.depthHeightEndValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.formObject,
                                "depthHeightEndValue",
                                _vm._n($$v)
                              )
                            },
                            expression: "formObject.depthHeightEndValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("v-checkbox", {
            attrs: {
              color: "error",
              label: "Test Run",
              "persistent-hint": "",
              hint: "See logs of the outcome without making any changes",
            },
            model: {
              value: _vm.assignOptions.isTestRun,
              callback: function ($$v) {
                _vm.$set(_vm.assignOptions, "isTestRun", $$v)
              },
              expression: "assignOptions.isTestRun",
            },
          }),
          _vm._v(" "),
          _vm.isSystemAdmin
            ? [
                _c("v-subheader", { staticClass: "pl-0 mt-2" }, [
                  _vm._v("System Administrator Settings"),
                ]),
                _vm._v(" "),
                _c("v-checkbox", {
                  staticClass: "mt-0",
                  attrs: {
                    color: "info",
                    label: "Make primary name",
                    "persistent-hint": "",
                    hint: "New synonym will become the primary name",
                  },
                  model: {
                    value: _vm.assignOptions.makePrimary,
                    callback: function ($$v) {
                      _vm.$set(_vm.assignOptions, "makePrimary", $$v)
                    },
                    expression: "assignOptions.makePrimary",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          key: "alert",
          staticClass: "my-0",
          attrs: {
            outline: "",
            type: "warning",
            value: _vm.assignOptions.makePrimary,
          },
        },
        [
          _c("div", { staticClass: "primary--text" }, [
            _vm._v(
              "\n      The primary alias name shows up in reports, which may cause confusion when the primary alias does not match\n      thelocation name.\n    "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }